module.exports = __webpack_public_path__ + "img/chat.28e4bc15.jpeg";